module.exports = __webpack_public_path__ + "img/loadingWheel.6ff13ec8.svg";